import { REPORT_DATA
   } from "../actionTypes/ReportActionTypes";

export const setReportData = (payload={},existState={}) => {
    const data = (payload) ? payload :{};
    return { 
      type: REPORT_DATA, 
      payload: data ,
      existState: existState
    };
};

